<template>
  <div class="index-wrapper">
    <section class="section1">
      <div class="section1-wrapper">
        <div class="slide-1">
          <div class="slide-box swiper-container swiper-style1">
            <ul class="swiper-wrapper">
              <li
                class="swiper-slide"
                v-for="item in newsPicture"
                :key="'new'+item.id"
                @touchend="toPage({name:'partyDetail',query:{id:item.id}})"
              >
                <div class="banner-wrapper">
                  <img class="banner-slide-one" :src="item.cover" alt>
                  <div class="banner-slide-text">{{item.title}}</div>
                </div>
              </li>
            </ul>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="section1-new">
          <div class="new-tab-list">
            <ul>
              <li v-for="(item,index) in newList" :key="'news'+item.id">
                <div
                  class="top-new-item common-new-item"
                  @touchend="toPage({name:'partyDetail',query:{id:item.id}})"
                >{{item.title}}</div>
                <!-- <a
                v-else
                  class="fffcolor top-new-item"
                  :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                  :href="item.link"
                >{{item.title}}</a> -->
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="more" @touchend="toPage({name:'brecruitment'})">
          <div class="more-bj"></div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script type="text/javascript">var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");document.write(unescape("%3Cspan id='cnzz_stat_icon_1277843947'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s23.cnzz.com/z_stat.php%3Fid%3D1277843947%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.slide-1 /deep/ .swiper-pagination-bullet-active,
.section2-slide /deep/ .swiper-pagination-bullet-active {
  background: #194eb0 !important;
}
.slide-1 /deep/ .swiper-pagination-bullet,
.section2-slide /deep/ .swiper-pagination-bullet {
  width: 12 / @rem;
  height: 12 / @rem;
  background: #fff;
  opacity: 1;
  bottom: 16 / @rem;
}
.section3 /deep/ .swiper-pagination-bullets {
  bottom: 18 / @rem;
}
.section3-slide /deep/ .swiper-pagination-bullet-active {
  border: 2px solid #194eb0 !important;
}
.section3-slide /deep/ .swiper-pagination-bullet {
  width: 30 / @rem;
  height: 30 / @rem;
  font-size: 24 / @rem;
  text-align: center;
  line-height: 30 / @rem;
  bottom: 40 / @rem;
  background: #fff !important;
  border: 1px solid #fff !important;
  color: #333;
  // opacity: 1;
}
.section3-slide /deep/ .swiper-pagination {
  width: 100%;
  text-align: right;
  box-sizing: border-box;
  padding-right: 40 / @rem;
}

.index-wrapper {
  background: #f2f2f2;
  .section1 {
    width: 100%;
    // height: 973 / @rem;
    // background: url(/static/img/index-bj.png) no-repeat center center;
    // background-size: 750 / @rem 973 / @rem;
    padding: 30px;
    box-sizing: border-box;
    .section1-wrapper {
      width: 690 / @rem;
      margin: 0 auto;
      background: #fff;
      border-radius: 10 / @rem;
      .slide-1 {
        width: 690 / @rem;
        height: 439 / @rem;
        box-sizing: border-box;
        .banner-wrapper {
          width: 100%;
          height: 419 / @rem;
          position: relative;
          .banner-slide-one {
            margin: 0 auto;
            // width: 670 / @rem;
            width: 100%;
            height: 419 / @rem;
          }
          .banner-slide-text {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            font-size: 24 / @rem;
            color: #fff;
            height: 90 / @rem;
            line-height: 80 / @rem;
            text-align: center;
            background: rgba(0, 0, 0, 0.2);
          }
        }
      }
      .section1-new {
        width: 100%;
        .section1-new-tab {
          display: flex;
          .item {
            width: 50%;
            line-height: 70 / @rem;
            text-align: center;
            font-size: 25 / @rem;
            color: #7e868f;
            background: #f3f4f5;
            span {
              display: inline-block;
              vertical-align: middle;
            }
            .icon1 {
              width: 25 / @rem;
              height: 70 / @rem;
              background: url("/static/img/activebumne.png") no-repeat center
                center;
              background-size: 25 / @rem 29 / @rem;
            }
            .icon2 {
              width: 35 / @rem;
              height: 70 / @rem;
              background: url("/static/img/news.png") no-repeat center center;
              background-size: 35 / @rem 26 / @rem;
            }
            .icon3 {
              width: 35 / @rem;
              height: 70 / @rem;
              background: url("/static/img/znq_gray@2x.png") no-repeat center center;
              background-size: 29 / @rem 29 / @rem;
            }
          }

          .tabActive {
            background: #194eb0;
            color: #fff;
            position: relative;
            .icon1 {
              background: url("/static/img/bumen.png") no-repeat center center;
              background-size: 25 / @rem 29 / @rem;
            }
            .icon2 {
              background: url("/static/img/newsactive.png") no-repeat center
                center;
              background-size: 35 / @rem 26 / @rem;
            }
            .icon3 {
              background: url("/static/img/znq_w@2x.png") no-repeat center
                center;
              background-size: 29 / @rem 29 / @rem;
            }
          }
          .tabActive::after,
          .tabActive:after {
            content: "";
            width: 0;
            height: 0;
            border-width: 16 / @rem;
            border-style: solid;
            border-color: #194eb0 transparent transparent transparent; /*透明 透明  黄*/
            position: absolute;
            bottom: -26 / @rem;
            left: 50%;
            transform: translateX(-50%);
            z-index: 10;
          }
        }
      }
    }
  }
  .section2 {
    width: 690 / @rem;
    margin: 0 auto;
    .zthd{
      display: block;
    }
    .xxhy {
      width: 690 / @rem;
      display: block;
      margin: 30 / @rem auto;
    }
    .section2-slide {
      .banner-wrapper {
        width: 100%;
        height: 433 / @rem;
        .banner-slide-one {
          margin: 0 auto;
          // width: 690 / @rem;
          width: 100%;
          height: 433 / @rem;
        }
      }
    }
  }
}
.section2-new {
  width: 100%;
  margin-top: 20 / @rem;
  .section2-new-tab {
    display: flex;
    .item {
      width: 33.333333%;
      line-height: 70 / @rem;
      text-align: center;
      font-size: 25 / @rem;
      color: #7e868f;
      background: #f3f4f5;
    }

    .tabActive {
      background: #e44024;
      color: #fff;
      position: relative;
    }
    .tabActive::after {
      content: "";
      width: 0;
      height: 0;
      border-width: 16 / @rem;
      border-style: solid;
      border-color: #e44024 transparent transparent transparent; /*透明 透明  黄*/
      position: absolute;
      bottom: -26 / @rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.section3 {
  width: 690 / @rem;
  margin: 0 auto;
  .section3-title {
    width: 100%;
    height: 70 / @rem;
    background: #275cc4;
    border-radius: 10 / @rem 10 / @rem 0 0;
    .section3-text {
      width: 118 / @rem;
      height: 70 / @rem;
      margin: 0 auto;
      background: url(/static/img/ggtz.png) no-repeat center center;
      background-size: 118 / @rem 28 / @rem;
    }
  }
  .section3-slide {
    .section2-img {
      margin: 0 auto;
      width: 690 / @rem;
      height: 433 / @rem;
      object-fit: fill;
    }
    .sw-wrapper {
      height: 433 / @rem;
      position: relative;
    }
    .section3-text {
      width: 100%;
      height: 80 / @rem;
      color: #fff;
      font-size: 24 / @rem;
      background: rgba(0, 50, 110, 0.5);
      position: absolute;
      bottom: 0;
      left: 0;
      line-height: 80 / @rem;
      padding-left: 100 / @rem;
      padding-right: 200 / @rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      box-sizing: border-box;
    }
    .section3-text::after {
      position: absolute;
      width: 80 / @rem;
      height: 80 / @rem;
      top: 0;
      left: 0;
      content: "重要活动";
      background: #085ccb;
      padding: 15 / @rem;
      box-sizing: border-box;
      font-size: 24 / @rem;
      line-height: 24 / @rem;
      text-align: center;
      white-space: normal;
    }
  }
}
.section4 {
  width: 690 / @rem;
  margin: 0 auto;
  .sec-img-41 {
    width: 80 / @rem;
    height: 16 / @rem;
    display: block;
    margin: 18 / @rem auto;
  }
  .sec-img-42 {
    width: 374 / @rem;
    height: 35 / @rem;
    display: block;
    margin: 18 / @rem auto 23 / @rem;
  }
  .section4-line {
    width: 120 / @rem;
    height: 8 / @rem;
    background: #275dc4;
    margin: 0 auto 46 / @rem;
  }
  .section4-center {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .section4-center-item {
    width: 50%;
    max-width: 217 / @rem;
    height: 289 / @rem;
    margin-bottom: 0 / @rem;
    border-radius: 10 / @rem;
    box-shadow: 0 0 25 / @rem rgba(195, 205, 224, 1);
  }
  .section4-center-item a {
    display: block;
    width: 100%;
    height: 289 / @rem;
    overflow: hidden;
  }
  .section4-center-item1 {
    margin-bottom: 30 / @rem;
    a {
      background: url(/static/img/icon1.png) no-repeat center center;
      background-size: 217 / @rem 289 / @rem;
    }
  }
  .section4-center-item2 {
    margin: 0 10 / @rem 30 / @rem;
    a {
      background: url(/static/img/icon2.png) no-repeat center center;
      background-size: 217 / @rem 289 / @rem;
    }
  }
  .section4-center-item3 {
    margin-bottom: 30 / @rem;
    a {
      background: url(/static/img/icon3.png) no-repeat center center;
      background-size: 217 / @rem 289 / @rem;
    }
  }
  .section4-center-item4 {
    margin-right: 10 / @rem;
    a {
      background: url(/static/img/icon4.png) no-repeat center center;
      background-size: 217 / @rem 289 / @rem;
    }
  }
  .section4-center-item5 {
    a {
      background: url(/static/img/zxbm.png) no-repeat center center;
      background-size: 217 / @rem 289 / @rem;
    }
  }
}
.section5 {
  width: 100%;
  height: 325 / @rem;
  background: url(/static/img/email.png) no-repeat center center;
  background-size: 750 / @rem 325 / @rem;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.section6 {
  width: 690 / @rem;
  height: 449 / @rem;
  margin: 0 auto;
  background: #fff;

  .link-bg {
    width: 100%;
    height: 50 / @rem;
    background: url(/static/img/link.png) no-repeat center center;
    background-size: 690 / @rem 50 / @rem;
  }
  .section5-select {
    width: 100%;
    background: #fff;
    border-radius: 0 0 10 / @rem 10 / @rem;
  }

  .select-item {
    width: 631 / @rem;
    height: 60 / @rem;
    line-height: 60 / @rem;
    margin: 25 / @rem auto;
    position: relative;
  }
  .select-item select {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
  }
  .select-item select::-ms-expand {
    display: none;
  }
  .select-item select {
    width: 100%;
    height: 60 / @rem;
    line-height: 60 / @rem;
    border: none;
    outline: none;
    border: 1 / @rem solid #dfdfdf;
    border-radius: 4 / @rem;
    box-sizing: border-box;
    padding: 0 48 / @rem 0 10 / @rem;
    color: #000;
    font-size: 24 / @rem;
    background: #f0f3f7;
  }
  .select-item select option {
    font-size: 24 / @rem;
  }
  .icon-down {
    position: absolute;
    top: 30 / @rem;
    right: 8 / @rem;
    display: block;
    width: 15 / @rem;
    height: 24 / @rem;
    background: url("/static/img/select.png") no-repeat center;

    background-size: 15 / @rem 24 / @rem;
  }
}
// 列表的公共样式

.new-tab-list {
  padding: 20 / @rem;
  // height: 280 / @rem;
  box-sizing: border-box;
  border-bottom: 1px solid #dadde1;
  background: #fff;
  li {
    font-size: 24 / @rem;
    color: #1b2464;
    line-height: 55 / @rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    position: relative;
    padding-left: 34 / @rem;
    div{
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      cursor: pointer;
    }
  }
  .top2-new-item::after {
    position: absolute;
    top: 17 / @rem;
    left: 0;
    content: "";
    background: url(/static/img/new-icon1.png) no-repeat center;
    background-size: 100% 100%;
    width: 29 / @rem;
    height: 21 / @rem;
  }
  .fffcolor {
    color: #1b2464 !important;
  }
  // .top-new-item::after {
  //   position: absolute;
  //   top: 17 / @rem;
  //   left: 0;
  //   content: "";
  //   background: url(/static/img/new-icon.png) no-repeat center;
  //   background-size: 100% 100%;
  //   width: 29 / @rem;
  //   height: 21 / @rem;
  // }
  .common-new-item::after {
    position: absolute;
    top: 21 / @rem;
    left: 8 / @rem;
    content: " ";
    background: #c8cbcf;
    width: 9 / @rem;
    height: 9 / @rem;
    border-radius: 50%;
  }
}
// 更多的公共样式
.more {
  width: 100%;
  height: 68 / @rem;
  background: #f3f4f5;
  border-radius: 0 0 10 / @rem 10 / @rem;
  .more-bj {
    width: 100 / @rem;
    height: 100%;
    background: url(/static/img/more.png) no-repeat center center;
    background-size: 68 / @rem 13 / @rem;
    margin: 0 auto;
  }
}
.shadow-bottom {
  width: 100%;
  height: 43 / @rem;
  background: url(/static/img/shadow-bottom.png) no-repeat center center;
  background-size: 750 / @rem 43 / @rem;
}
</style>
<script>
import Vue from "vue";
import "../../../static/css/swiper-4.1.0.min.css";
import Swiper from "../../../static/js/swiper-4.1.0.min.js";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      newsFlag: "2",
      section: "2",
      noticeList: [], //重要公告列表
      activityList: [], //重要活动列表
      newList: [],
      partyList: [],
      partyPicture: [],
      newsPicture: [],
      partyactivety: [],
      friendLinkList: [],
      goUrl:''
    };
  },
  computed: {
    ...mapGetters(["touchflg"])
  },
  methods: {
    ts(){
      alert('暂未开放');
    },
    toPage(url) {
      if (this.touchflg) {
        this.$router.push(url);
      }
    },
    swiperDom() {
      var swiper = new Swiper(".swiper-style1", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: false,
        paginationClickable: true,
        slideToClickedSlide: true,
        preventLinksPropagation: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      });
    },
    // 获取新闻的首页列表文章类型，1推荐新闻，2部内要闻，3中心要闻，4活动新闻
    getNewList() {
      const params = {
        page: 1,
        count: 100
      };
      userApi.getBuildingList(params).then(res => {
        this.newList = res.data.list;
      });
    },
    //获取新闻的轮播 最上面
    getNewPicture() {
      let _this = this;
      userApi.getBuildingSwiper().then(res => {
        _this.newsPicture = res.data.list;
        Vue.nextTick().then(function() {
          _this.swiperDom();
        });
      });
    },
    tabNews(flag) {
      // 获取首页新闻的列表
      this.newsFlag = flag;
      this.getNewList();
    }
  },
  mounted() {
    this.getNewList();
    this.getNewPicture();
    // Vue.nextTick().then(function() {
    //   swiperDom();
    //   swiperDom2();
    // });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PartyBuilding/partyBuilding.vue